import axios from 'axios'

export default class OrderApi {
    constructor(api) {
        this.$api = api
    }

    findInvoice() {
        return axios({ url: '/order/Invoice' })
    }

    invoiceDownload(params) {
        return axios({ url: '/order/invoiceDownload', method: 'post', data: params, responseType: 'arraybuffer' }).then((response) => {
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            let e = document.createEvent('MouseEvents')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.headers['x-filename']
            e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            link.dispatchEvent(e)
        })
    }

}



// WEBPACK FOOTER //
// ./src/api/OrderApi.js